import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import { message, Pagination } from "antd";
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import {
  getAdminNotifications,
  deleteThisNotification,
} from "../../Web Apis/Apis";
import SendNotification from "./SendNotification";

function AdminNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [action, setAction] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage] = useState(10);

  // Calculate the current items for the page
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setNotifications("");

      const response = await getAdminNotifications(currentPage, itemsPerPage);
      if (response?.data?.success) {
        
        setNotifications(response?.data?.data?.content);
        setTotalPages(response?.data?.data?.totalPages);
      }
    } catch (error) {
      console.log("Error while fetch relation category", error.message);
      if (
        error.message === "Network Error" ||
        error.message.includes("ERR_INTERNET_DISCONNECTED")
      ) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert(
          "Your account is logged in to another device, please login again !"
        );
        localStorage.clear();
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [currentPage, action]);

  // const handleUpdateModalOpen = () => {

  // }

  const handleDeleteModalOpen = (notify) => {
    setSelectedNotification(notify);
    setDeleteModalOpen(true);
  };

  const deleteNotification = async () => {
    try {
      setLoading(true);

      const response = await deleteThisNotification(selectedNotification.id);
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setDeleteModalOpen(false);
        setAction(!action);
      }
    } catch (error) {
      console.log("Error while deleting category", error.message);
      message.error(error?.response?.data?.message || "Error occured");
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotification = async () => {
    setSendModalOpen(true);
  };

  // const currentNotifications = notifications?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="p-4">
      <div className="flex justify-between">
        <h3 className="text-3xl font-bold"> Notification Management</h3>
        <div className="flex justify-end">
          <button
            onClick={handleSendNotification}
            className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
          >
            Send Notification
          </button>
        </div>
      </div>

      <table className="min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black">
        <thead>
          <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Title</th>
          <th className="py-2 px-4 border-b text-center">Body</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
        </thead>
        {notifications?.length > 0 ? (
          notifications?.map((notify, index) => (
            <tr
              key={notify.id}
              className={`hover:bg-gray-200 text-center transition duration-200 ${
                index % 2 === 0 ? "bg-white" : "bg-gray-300"
              }`}
            >
              <td className="py-2 px-4 border-b">
                {currentPage * itemsPerPage + index + 1}
              </td>
              <td className="py-2 px-4 border-b">{notify.title}</td>
              <td className="py-2 px-4 border-b">{notify.body}</td>

              <td className="py-2 px-4 border-b ">
                <div className="flex flex-row justify-center ">
                  {/* <button
                                                  onClick={() => handleViewModalOpen(category)}
                                                  className="text-blue-500 hover:text-blue-700 flex items-center"
                                                >
                                                  <AiOutlineEye className="mr-1 text-2xl" />
                                                </button> */}
                  {/* <button
                                                   onClick={() => handleUpdateModalOpen(notify)}
                                                   className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                                 >
                                                   <AiFillEdit className="mr-1 text-2xl" />
                                                </button> */}
                  <button
                    onClick={() => handleDeleteModalOpen(notify)}
                    className="text-red-500 hover:text-red-700 flex items-center"
                  >
                    <AiFillDelete className="mr-1 text-2xl" />
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan="7"
              className=" px-4 py-4 border-b text-center font-bold"
            >
              No notifications data found
            </td>
          </tr>
        )}

        <tbody></tbody>
        {loading && <Loader />}
      </table>

      <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={totalPages * itemsPerPage}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>

      {sendModalOpen && (
        <SendNotification
          sendModalOpen={sendModalOpen}
          setSendModalOpen={setSendModalOpen}
          action={action}
          setAction={setAction}
        />
      )}

      {deleteModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">
              Confirm Delete
            </h3>
            <p className="mb-4 text-start text-white">
              Are you sure you want to delete this category ?{" "}
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => {
                  setDeleteModalOpen(false);
                }}
                className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200"
              >
                Cancel
              </button>
              <button
                onClick={deleteNotification}
                className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminNotifications;
